import * as Api from '@ViewModels';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import medicareProLogo from '../../../assets/logo_medicarepro.png';
import { ApiKeyIntegrationPage } from '../ApiKeyIntegrationPage';

export function MedicarePro() {
	const userSession = useUserSession();

	return (
		<ApiKeyIntegrationPage
			provider={Api.IntegrationProvider.MedicarePro}
			integrationType={Api.ExternalIntegrationType.MedicarePro}
			displayName='MedicarePRO'
			logo={medicareProLogo}
			logoAlt='MedicarePRO CRM Logo'
			description='Levitate can sync with MedicarePRO CRM to pull client information, including names, email and physical mailing addresses, phone numbers, policies, and more.'
			credentialLabel='API Token'
			credentialNoun='API token'
			connectPrompt="To get started, create an API token in MedicarePRO CRM under Settings → API Tokens → Generate New Token. Give the token a recognizable name, such as “Levitate,” and leave the expiration date blank so the sync isn't interrupted when the token expires. Then paste the token below."
			manageConnectedText='Your MedicarePRO clients will show up in the contacts tab, with their policies on their profiles.'
			manageNotConnectedText='Once you are configured, your MedicarePRO clients will show up in the contacts tab.'
			disconnectTitle='Disconnect MedicarePRO? Levitate will stop syncing client data from your MedicarePRO account. You can reconnect at any time by entering your API token again.'
			onConnected={() => {
				// While impersonating, these pending actions are the admin's.
				if (!userSession.impersonationContext?.account?.id) {
					userSession.resolvePendingAction(Api.PendingActions.ConnectMedicarePro);
					// So a later rejected token isn't hidden by an old dismissal.
					window.localStorage.removeItem(Api.PendingActions.ConnectMedicarePro);
				}
			}}
		/>
	);
}
